import getComponentTokens from './index';
export default function getTransformedComponentTokens() {
    return getComponentTokens();
}
